import React from 'react';
import InlineBalanceEdit from './FormComponents/InlineBalanceEdit';

const BalanceRecordRow = ({ 
  record, 
  index, 
  disabled, 
  editingRecord, 
  submitting, 
  isValueChanged,
  formatDate,
  startEditing,
  handleInputChange,
  handleUpdateBalance,
  confirmDelete,
  cancelEditing
}) => {
  const getEndDateDisplay = () => {
    if (record.endDate) {
      return formatDate(record.endDate);
    } else {
      const startDate = new Date(record.startDate);
      const currentDate = new Date();
      return "-";
    }
  };

  return (
    <tr>
      <td>{formatDate(record.startDate)}</td>
      <td>{getEndDateDisplay()}</td>
      <td>
        {editingRecord === record._id ? (
          <InlineBalanceEdit 
            recordId={record._id}
            defaultValue={record.balance}
            isValueChanged={isValueChanged}
            submitting={submitting}
            onInputChange={handleInputChange}
            onSave={handleUpdateBalance}
            onCancel={cancelEditing}
          />
        ) : (
          <div className="employee-balance-display">
            <span>{record.balance}</span>
            {!disabled && (
              <button 
                className="employee-balance-edit-btn"
                onClick={() => startEditing(record)}
              >
                ✎
              </button>
            )}
          </div>
        )}
      </td>
      {!disabled && (
        <td>
          {index === 0 ? (
              <div className="employee-balance-tooltip-wrapper">
                <div className="employee-balance-tooltip">Cannot delete this one</div>
                <span>-</span>
              </div>
          ) : (
            <button
              type="button"
              className="employee-balance-delete-btn"
              onClick={() => confirmDelete(record._id)}
            >
              🗑️
            </button>
          )}
        </td>
      )}
    </tr>
  );
};

export default BalanceRecordRow; 